import Errors from '../../utils/Errors';
import emailValidator from 'email-validator';
import DeliverTimes from "../../constants/DeliverTimes";

const validateOrder = (senderName, senderEmail, amount, sendToSender, recipientName, recipientEmail, deliveryTimeType, deliveryDateTime) => {
    let errors = new Errors();
    errors = errors.clearAll();
    if(senderName === null || senderName.length === 0) {
      errors = errors.addError('senderName', 'error.name-required');
    }

    if(senderEmail === null || senderEmail.length === 0) {
      errors = errors.addError('senderEmail', 'error.email-required');
    }
    else if(!emailValidator.validate(senderEmail)) {
      errors = errors.addError('senderEmail', 'error.email-not-valid');
    }

    if(amount === null || amount <= 0) {
      errors = errors.addError('amount', 'error.amount-greater-than-zero');
    }

    if (!sendToSender) {
      if(recipientName === null || recipientName.length === 0) {
        errors = errors.addError('recipientName', 'error.name-required');
      }

      if(recipientEmail === null || recipientEmail.length === 0) {
        errors = errors.addError('recipientEmail', 'error.email-required');
      }
      else if(!emailValidator.validate(recipientEmail)) {
        errors = errors.addError('recipientEmail', 'error.email-not-valid');
      }
    }

    if (deliveryTimeType === DeliverTimes.FUTURE) {
      if (deliveryDateTime === null || !(deliveryDateTime instanceof Date)) {
        errors = errors.addError('deliveryDateTime', 'error.deliver-date-required');
      }
    }

    if(errors.hasError('senderName') || errors.hasError('senderEmail') || errors.hasError('recipientName') || errors.hasError('recipientEmail') || errors.hasError('amount') || errors.hasError('deliveryDateTime')) {
      return Promise.reject(errors);
    }
    return Promise.resolve();
};

export default validateOrder;
